import { Router } from '@angular/router';

export class Action {

    active = true;

    constructor(public group:string, public label: string, public goTo : any[], public params: any) {}

    execute() { }
}

export class GotoAction extends Action {

    constructor(
        public group: string,
        public label: string,
        public goTo: any[],
        public params : any,
        public router: Router
    ) {
        super(group, label, goTo, params);
    }

    execute() {
        this.router.navigate(this.goTo);
    }
}

export class ModalAction {
    
    active = true;

    constructor(
        public group: string,
        public label: string,
        public component: any,
        public params : any = []
    ) {
        
    }
}

export class ScrollToAction extends Action {
 
    constructor(
        public group: string,
        public label: string, 
        private el: any) {
      super(group, label,[], {});
    }
  
    execute() {
        this.el.section.nativeElement.scrollIntoView();
    }
}

export class CallbackAction extends Action {
 
    constructor(
        public group: string,
        public label: string, 
        private callback:Function) {
      super(group, label,[], {});
    }
  
    execute() {
        this.callback();
    }
  }